/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Started/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Pause from './Pause/index'
import ProtocolTitle from './ProtocolTitle/index'
import React from 'react'
import StopAction from './StopAction/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Started({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/DentalMonitoring/Content/Started"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<ProtocolTitle
  viewPath={`${viewPath}/ProtocolTitle`}
/>
<div
  data-testid="Started.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-ZgMrKS': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<Pause
  viewPath={`${viewPath}/Pause`}
/>
<StopAction
  viewPath={`${viewPath}/StopAction`}
/>
</div>
{children}
</React.Fragment>)
}